<template>
    <div class="login-container">
        <el-form
            v-if="formType=== 'login'"
            ref="loginForm"
            :model="loginForm"
            :rules="loginRules"
            class="login-form"
            auto-complete="on"
            label-position="left"
        >
            <div class="c-flex-ajcenter title_box">
                <h3 class="title">{{ $t('login.title') }}</h3>
                <LangSelect class="lang" />
            </div>
            <!-- <p class="stystem_title">上海市书法家协会征稿系统</p> -->
            <!-- <p class="stystem_title">欢迎登录</p> -->
            <el-form-item prop="mobile">
                <el-input
                    v-model="loginForm.mobile"
                    name="mobile"
                    type="text"
                    auto-complete="on"
                    :placeholder="$t('login.mobile')"
                >
                    <i slot="prefix" class="el-icon el-icon-mobile-phone" />
                </el-input>
            </el-form-item>
            <el-form-item prop="password">
                <el-input
                    v-model="loginForm.password"
                    :type="pwdType"
                    name="password"
                    autocomplete="on"
                    auto-complete="off"
                    :placeholder="$t('login.password')"
                    @keyup.enter.native="handleLogin"
                >
                    <i slot="prefix" class="el-icon el-icon-lock" />
                    <i slot="suffix" class="el-icon el-icon-view" :class="{'el-icon-view-actived':!pwdType}" @click="showPwd" />
                </el-input>
            </el-form-item>
            <el-form-item>
                <el-button
                    class="login-btn"
                    :loading="loading"
                    size="medium"
                    type="primary"
                    style="width:100%;"
                    @click.native.prevent="handleLogin"
                >{{ $t('login.loginIn') }}</el-button>
            </el-form-item>
            <div class="other">
                <p @click="changeFormType('register')">{{ $t('login.register') }}</p>
                |
                <!-- <p @click="changeFormType('password')">修改密码</p>
            | -->
                <p @click="changeFormType('reset')">{{ $t('login.reset') }}</p>
            </div>
        </el-form>
        <!-- 注册 -->
        <Register
            v-if="formType=== 'register'"
            ref="register"
            @hancleChange="changeFormType"
            @submit="submitRegister"
        />
        <!-- 修改密码 -->
        <!-- <EditPassword
        v-if="formType=== 'password'"
        ref="password"
        @hancleChange="changeFormType"
        @submit="submitPassword"
        /> -->
        <!-- 重置密码 -->
        <ResetPassword
            v-if="formType=== 'reset'"
            ref="reset"
            @hancleChange="changeFormType"
            @submit="submitResetPassword"
        />
    </div>
</template>

<script>
import LangSelect from '@/components/LangSelect'
import mix_user from './mix_user'
import Register from './component/register'
// import EditPassword from './component/editPassword'
import ResetPassword from './component/resetPassword'
import { getTid, setTid } from '@/utils/cookies'
import { register, password, resetPassword } from '@/api/Auth'

export default {
    name: 'Login',
    components: { Register, ResetPassword, LangSelect },
    mixins: [mix_user],
    data() {
        return {
            tid: this.$route.query.tid ? this.$route.query.tid : getTid(),
            formType: 'login',
            froms: '',
            loginForm: {
                mobile: '',
                password: ''
            },
            redirect: undefined
        }
    },

    beforeRouteEnter: (to, from, next) => {
        console.log('from', from)
        next(vm => {
            vm.froms = from.path
        })
    },

    created() {
        this.tid ? setTid(this.tid) : ''
    },

    methods: {
        changeFormType(type) {
            this.formType = type
        },

        handleLogin() {
            this.$refs.loginForm.validate(valid => {
                if (valid) {
                    this.loading = true
                    this.$store
                        .dispatch('user/login', this.loginForm)
                        .then(async() => {
                            this.$notify({
                                title: this.$t('Notification.suc_title'),
                                message: this.$t('Notification.suc_login_msg'),
                                type: 'success',
                                duration: 2000
                            })
                            this.loading = false
                            // console.log('login--', this.$route.query)
                            await this.$store.dispatch('tougao/getTouGaoInfo', { id: this.tid })
                            this.$router.push({ path: this.froms, query: this.$route.query })
                        })
                        .catch(() => {
                            this.loading = false
                        })
                } else {
                    console.log('error submit!!')
                    return false
                }
            })
        },

        submitRegister(data) {
            console.log('submitRegister', data)
            register(data).then(res => {
                if (res.code === 200) {
                    this.$notify({
                        title: this.$t('Notification.suc_title'),
                        message: this.$t('Notification.suc_register_msg'),
                        type: 'success',
                        duration: 2000
                    })
                    setTimeout(() => {
                        this.changeFormType('login')
                    }, 1000)
                }
            })
        },

        submitPassword(data) {
            console.log('submitPassword', data)
            password(data).then(res => {
                this.$notify({
                    title: this.$t('Notification.suc_title'),
                    message: this.$t('Notification.suc_edit_msg'),
                    type: 'success',
                    duration: 2000
                })
                setTimeout(() => {
                    this.changeFormType('login')
                }, 1000)
            })
        },

        submitResetPassword(data) {
            console.log('submitResetPassword', data)
            resetPassword(data).then(res => {
                this.$notify({
                    title: this.$t('Notification.suc_title'),
                    message: this.$t('Notification.suc_reset_msg'),
                    type: 'success',
                    duration: 2000
                })
                setTimeout(() => {
                    this.changeFormType('login')
                }, 1000)
            })
        }
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import '../../styles/login';
.login-container {
  position: fixed;
  height: 100%;
  width: 100%;
  background:#f5f5f5;
  // background: url('../../assets/images/bg.png') no-repeat;
  // background-size: 100% 100%;
}
</style>
